<template>
  <DatePicker
    v-model="item.value"
    :type="item.type"
    :format="item.format || 'yyyy-MM-dd'"
    :placeholder="item.placeholder"
    editable
    transfer
    :readonly="item.readonly"
    :disabled="item.disabled"
    @on-change="(val) => item.onChange && item.onChange({ val, item, formItems })"
  ></DatePicker>
</template>
<script>
import props from './props'
export default {
  name: 'form-item-date-picker',
  mixins: [props],
  data () {
    return {}
  }
}
</script>